import * as React from "react";
import { merge } from "glamor";
import theme from "styles/theme";

interface IProps {
    value: number;
    card: boolean;
    list: boolean;
}

const BulkDragBadge: React.FC<IProps> = (props) => {
    const { value, card, list } = props;

    const styles = React.useMemo(() => {
        return merge({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            left: "-12px",
            top: "-8px",
            width: "44px",
            height: "34px",
            borderRadius: "20px",
            backgroundColor: theme.palette.primary1Color,
            zIndex: 99,
            color: "white",
            fontSize: "1.48rem",
        });
    }, []);

    return <div {...styles}>{value}</div>;
};

export default BulkDragBadge;
